import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { primaryButtonBase, secondaryButtonBase } from "../styles/buttonStyles";
import { useCalPopup } from "../utils/useCalPopup";

const PrimaryBtn = styled.button`
    ${primaryButtonBase}
    padding: 0.875rem 1.75rem;
    font-size: 1rem;
`;

const GhostBtn = styled.button`
    ${secondaryButtonBase}
    padding: 0.875rem 1.75rem;
    font-size: 1rem;
    font-weight: 600;
    border: 1px solid ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};

    svg {
        color: ${({ theme }) => theme.primary};
    }

    &:hover:not(:disabled) {
        background: ${({ theme }) => `${theme.primary}15`};
    }
`;

/**
 * Opens a Cal.com booking popup for the given event type.
 * variant: "primary" (bracketed terminal entry) | "ghost" (plain outline).
 */
const BookButton = ({ event = "30min", variant = "primary", color, children }) => {
    const calProps = useCalPopup(event);
    const Btn = variant === "ghost" ? GhostBtn : PrimaryBtn;

    return (
        <Btn {...calProps} color={color}>
            <FontAwesomeIcon icon={faCalendarDays} />
            {children}
        </Btn>
    );
};

export default BookButton;
